import React from 'react';
import styled from '@emotion/styled';
import { ITheme, Shimmer, ShimmerPlaceholderText } from '../../../../ui';
import { Color } from '../../../shared/styles/Color';
import Responsive from '../../../../ui/utils/Responsive';
import { StyledVehiclesHeading } from './VehiclesEmptyStateContainer';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';

export const VehiclesShimmer = ({
	size,
}: {
	size?: 'small' | 'medium' | 'large';
}) => {
	const { t } = useTranslation();
	const shimmerSize = size || 'medium';

	return (
		<StyledVehicleCard>
			<StyledVehiclesHeading>
				{t('account_vehicles_label')}
			</StyledVehiclesHeading>
			<Shimmer aria-label="shimmer">
				<VehicleCardContainer>
					<VehicleCardShimmer size={shimmerSize} />
					<VehicleCardShimmer size={shimmerSize} />
				</VehicleCardContainer>
			</Shimmer>
		</StyledVehicleCard>
	);
};

const StyledVehicleCard = styled.div`
	--card-padding: 0;
	padding: var(--card-padding, 24px);
	background: var(--card-background, white);
	box-shadow: '0px 2px 10px -2px rgba(0, 0, 0, 0.14)';
	--webkit-box-shadow: '0px 2px 10px -2px rgba(0, 0, 0, 0.14)';
	border-radius: 8px;
`;

const VehicleCardContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 24px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
	}
`;

const VehicleCardShimmer = styled(ShimmerPlaceholderText)<
	{ size?: 'small' | 'medium' | 'large' },
	ITheme
>`
	width: ${({ size }) =>
		size === 'small' ? '300px' : size === 'large' ? '464px' : '360px'};
	height: ${({ size }) => (size === 'small' ? '120px' : '180px')};
	background: ${Color.Surface};
	border-radius: 10px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
	}
`;
